import * as API from 'src/api';

import { ISendPollResponsesResponse, ISendPollResponsesRequest } from '../types';

const API_ENDPOINT_POLLS = 'save-poll-response';

export async function sendResponses(
  data: ISendPollResponsesRequest,
): Promise<PollAnswer[]> {
  return API.request<ISendPollResponsesResponse>({
    method: 'post',
    url: API_ENDPOINT_POLLS,
    data,
  }).then((response) => response.response.pollAnswers);
}
